module.exports = __webpack_public_path__ + "img/gan_rina_no.446a7080.png";